<template>
  <div class="container">
    <div class="top-container">
      <div class="top-container-inner">
        <div id="top" class="step">
          <Step :currentStep=0 :steps="steps" />
        </div>
        <div class="title">
          <h1>お申し込み情報</h1>
        </div>
      </div>
    </div>
    <div class="l-container child-container">
      <div class="box">
        <div class="box-content">
          <div>
            <Item :data="dataItemOrder" />
          </div>
          <div class="checkbox-confirm-lg relative">
            <span>事前に施設へ直接<span class="text-button pl-0">電話予約</span>の上、補助金申請を行なってください。</span>
          </div>
          <div class="menu-content2">
            <SectionContentTitle
              :lineType="lineType.vertical"
              titleContent="お申し込み内容"/>
            <div class="content">
              <table class="table-common">
                <tr class="label-inp">
                  <td class="flex style-l">
                    <div class="font-bold label-l">ご宿泊期間</div>
                  </td>
                  <td class="data">
                    <div class="flex flex-wrap items-center">
                      <div class="mb-2 mr-2">
                        <a-date-picker
                          v-model.lazy="stayDateRoom.date"
                          class="w-36"
                          type="date"
                          placeholder="YYYY/MM/DD"
                          format="YYYY/MM/DD"
                          :disabledDate="checkDisabledDate"
                          :allowClear="false"
                          @change="onChangeCheckinTm"
                        />
                        日から
                      </div>

                      <div class="mb-2">
                        <a-select v-model.number.lazy="stayDateRoom.stayNight" class="w-16">
                          <a-select-option
                            v-for="item in stayNightOptions"
                            :key="`stayNight-${item}`"
                            :value="item.value"
                          >
                            {{ item.text }}
                          </a-select-option>
                        </a-select>
                        泊

                        <a-select
                          v-model.number.lazy="stayDateRoom.stayRoom"
                          class="w-16"
                        >
                          <a-select-option
                            v-for="item in roomOptions"
                            :key="`stayNight-${item}`"
                            :value="item.value"
                          >
                            {{ item.text }}
                          </a-select-option>
                        </a-select>
                        部屋

                        <button
                          @click="onAddStayNightAndRoom"
                          class="ml-3 w-20 c-btn btn-white py-1"
                        >
                          <span class="">変更</span>
                        </button>
                      </div>
                    </div>
                    <div class="text-left mb-2" v-show="errMsgStayDateRoom" ref="stay-date-room">
                      <span class="font-14 font-bold text-primary">
                        {{errMsgStayDateRoom}}
                      </span>
                    </div>
                    <div>※一泊で複数のお部屋を利用される場合は、ご利用部屋数をご入力後に「変更」ボタンを押してください。</div>
                  </td>
                </tr>
                <tr class="label-inp"></tr>
              </table>
              <div class="room-eyes">
                <div class="title-room">1部屋目</div>
                <div class="whitespace-pre-wrap mb-4" v-html="roomBasicInfoNote" />
                <div class="room-table" ref="roomRef">
                <PeopleOfRoom
                  v-for="(_, idx) in stayRoomDetails"
                  v-model="stayRoomDetails[idx]"
                  :arrInputPriceErrorMsg="arrInputPriceErrorMsg"
                  :arrCheckPriceLessThanOne="arrCheckPriceLessThanOne"
                  :arrCheckAmountPeopleInputErrMsg="arrCheckAmountPeopleInputErrMsg"
                  :roomErrors="getNestedValue(roomErrors, `[${idx}]`, [])"
                  :numRoom="idx"
                  @input="stayRoomDetails[idx] = $event"
                  :key="`people-in-room-${idx}`"
                />
                <div class="room-btn-confirm flex justify-end mt-2" ref="checkRelationshipError">
                  <Button
                    class="btn-confirm"
                    text="人数確定"
                    type="dark"
                    @click="confirmRoomPeople"
                  />
                </div>
                <div class="warning-box" v-show="(bothRoomError && bothRoomError.length)">
                  <div
                    class="both-room-error-msg text-error text-right font-14"
                    v-for="(error, idx) in bothRoomError"
                    :key="`both-room-error-msg-${idx}`">
                    {{ error }}
                  </div>
                  </div>                  
                </div>
              </div>
              <div class="mb-8" v-show="showRelationship">
                <SectionContentTitle
                  lineType="v-line"
                  titleContent="続柄選択"
                  class="mb-8"
                />
                <PeopleRelationship
                  :stayRoomDetails="tempStayRoomDetails"
                  :visible="showRelationship"
                  :showRelationName="showRelationName"
                  @input="onRelationshipChange"
                  @adultCnt="getAdultCntMember($event)"
                  @messageErrorAge="getMessageErrorAge($event)"
                  @messageErrorSei="getMessageErrorSei($event)"
                  @messageErrorMei="getMessageErrorMei($event)"
                  :isReRenderListRoom="isReRenderListRoom"
                  :publicStay=true
                />
                <div class="font-bold text-primary">
                  {{ error_message_age_relationship }}
                </div>
                <div class="font-bold text-primary">
                  {{ error_message_sei_relationship }}
                </div>
                <div class="font-bold text-primary">
                  {{ error_message_mei_relationship }}
                </div>
                <span class="rel-note block mb-8 lg:mb-4"
                >
                  ※一部ご加入コースにより、会員様範囲が異なる場合もございます。<br />※Beneオリジナルプランでご予約の場合、ビジター区分にあたる同行者様は入力不要です。<br />会員ご本人様を含めた会員区分の方のみご入力ください。</span
                >
              </div>

              <table class="table-common">
                <tr class="label-inp">
                  <td class="flex style-l">
                    <div class="font-bold label-l">ご自宅出発日</div>
                  </td>
                  <td class="data">
                    <div class="flex flex-wrap items-center">
                      <div class="mb-2 mr-2">
                        <a-date-picker
                          v-model="departureTime"
                          class="w-36"
                          type="date"
                          placeholder="YYYY/MM/DD"
                          format="YYYY/MM/DD"
                          :disabledDate="checkDisabledDate"
                          :disabled="+this.fromWebRadio === 1"
                          :allowClear="false"
                          @change="onChangeDeparture"
                        />
                      </div>
                    </div>
                  </td>
                </tr>
                <tr class="label-inp">
                  <td class="style-l">
                    <div class="font-bold label-l w-full">ご利用案内書の受け取り方法</div>
                  </td>
                  <td class="data">
                <div class="items-data">
                  <div class="label-data menber">
                    <div class="elm gap-2">
                      <a-radio-group class="flex address" v-model="fromWebRadio" name="radioGroup" :default-value="0" @change="onChangeWeb">
                        <a-radio class="pt-1" :value="1">
                          WEBからプリントアウト
                        </a-radio>
                        <a-radio class="radio-top pt-1" :value="2">
                          郵送
                        </a-radio>
                      </a-radio-group>
                    </div>
                  </div>
                </div>
                  </td>
                </tr>
                <tr class="label-inp"></tr>
              </table>

              <div class="text-left" v-show="errorMessageHour && +fromWebRadio === 1">
                <span class="font-14 font-bold text-primary">
                  {{ errorMessageHour }}
                </span>
              </div>
              <div class="text-left" v-show="+fromWebRadio <= 0 && statusError">
                <span class="font-14 font-bold text-primary">
                  受け取り方法を選択してください
                </span>
              </div>
              <div class="flex flex-col text-left" v-show="hasNext && errMsgDeparuteTime.length">
                <span class="font-bold font-14 text-primary" v-for="(msg, idx) in errMsgDeparuteTime" :key="`departure-error-${idx}`">
                  {{ msg }}
                </span>
              </div>
              <div class="pt-3">
                ※ご利用当日、現地にて利用案内書のご提出は必須となります。
              </div>
              <div>
                ※『WEBからプリントアウト』を選択の場合は、ご自身で申込完了画面または、ホームページの「ご利用履歴」よりプリントアウトをお願いいたします。
              </div>
              <div>
                ※補助金の不正申請が発覚した場合は、補助金の全額返金および今後の補助金申請を無効とさせていただく場合がございます。予めご了承ください。
              </div>
              </div>
              <ConfirmRequire @change="changeConfirmRequire" />

              <a-divider /> 

              <div class="buttons flex gap-2 justify-center mt-4 mb-4">
                <button @click="handleBack" class="c-btn btn-white">
                  <span class="">戻る</span>
                </button>
                <button class="c-btn btn-black" 
                  :class="[isAcceptRequire ? 'btn-grey' : 'disabled-btn']"
                  :disabled="!isAcceptRequire"
                  @click="handleNext">
                次へ
                </button>
              </div>
              <div
                class="note-master"
                v-for="(i, index) in noteMatters"
                :key="`noteMatters-${index}`"
              >
                <div class="title">
                  {{ i.title }}
                </div>
                <div class="content">
                  {{ i.content }}
                  <div class="url">
                    <a :href="`${i.linkUrl}`">{{ i.linkNm }} {{ i.linkUrl }}</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
    </div>
  
  </div>
  
</template>

<script>
import func_utils from '@/mixins/func_utils'
import { Item, SectionContentTitle, Step } from '@/components/compound'
import PeopleOfRoom from './components/PeopleOfRoom'
import ConfirmRequire from './components/ConfirmRequire'
import { TIME_OPTIONS, TIME_PICKER } from '@/constants/date_time'
import MESSAGE_ERROR from '@/constants/message_error.json'
import moment from 'moment'
import get from 'lodash/get'
import cloneDeep from 'lodash/cloneDeep'
import { GET_PROFILE, SAVE_SELECTED_WEB_RADIO, SAVE_PUBLIC_STAY, SAVE_DATA_BS_APP_02_001, } from '@/store/modules/bs_app/actions'
import { SAVE_CUSTOMER_PLAN } from '@/store/modules/plan/actions'
import _ from 'lodash'
import PeopleRelationship from '@/components/PeopleRelationship'
import { generateRoomDetailsForApplyCoupon } from '../utils/dataConverters'

export default {
  mixins: [func_utils],

  components: {
    Step,
    Item,
    SectionContentTitle,
    PeopleOfRoom,
    ConfirmRequire,
    PeopleRelationship
  },

  data() {
    return {
      customerPlan: null,
      menuStayParams: null,
      hasError: false,
      showForm: false,
      valueCheckbox1: false,
      valueCheckbox: false,
      fromWebRadio: 0,
      totalPoint: 0,
      statusError: false,
      titleContent: ['お申し込み内容', '申込者情報'],
      lineType: { horizontal: 'h-line', vertical: 'v-line' },
      maxLength: 100,
      checkboxMobile: false,
      steps: [
        {
          id: 1,
          label: '申請内容を入力'
        },
        {
          id: 2,
          label: '申請者情報を入力'
        },
        {
          id: 3,
          label: '補助金利用申請'
        },
        {
          id: 4,
          label: '申込内容確認'
        },
        {
          id: 5,
          label: '申込完了'
        }
      ],
      rela: [
        {
          label: '本人',
          value: '本人'
        },
        {
          label: '妻夫',
          value: '妻夫'
        },
        {
          label: '子ども',
          value: '子ども'
        }
      ],
      inputFormData: {
        familyName: '',
        firstName: '',
        familyNameKana: '',
        firstNameKana: '',
        familyRelationship: '選択してください',
        isVisitor: null,
        gender: null,
        age: null,
        error_message_name: null,
        error_message_name_kana: null,
        error_message_rela: null,
        error_message_visitor: null,
        error_message_gender: null,
        error_message_age: null
      },
      checkinTime: null,
      checkinTimeOptions: TIME_PICKER,
      options: TIME_OPTIONS,
      dataItemOrder: {},
      caution: {
        caution1:
          '※ 会員ご本人及び配偶者の各2親等以内の方は「会員」欄にご利用人数を入力してください。（一部ご加入コースにより会員様範囲が異なる場合もございます）',
        caution2:
          '※ 利用者内訳に子どもがない場合は、子どもも大人の扱いになります。（大人と同様）',
        caution3: '※ 子どもは小学生までです。',
        caution4: '※ 幼児は0才児〜未就学児までです。'
      },
      errors: [],
      info_facilities: {
        description1: '入湯税が別途必要です。（お一人様大人のみ150円）',
        description2: '駐車場台が別途必要です。（1台500円）'
      },
      info_confirms: {
        description1:
          '交通手段をお知らせください。お子さま（幼児：4歳〜小学校入学前/小学生）が宿泊される場合は、年齢/男女別をお知らせください。',
        description2: '※幼児のお子さまは年齢の記入をお願いします。',
        description3:
          'テキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキスト・・・'
      },
      contact_facilities:
        '本ページにて入力いただいた内容以外に施設へ事前にお伝えしたい事項がある場合には、予約申込後、直接施設へご連絡いただきますようお願い申し上げます。（例：食品アレルギーなど）なお、予約直後は施設側での予約処理が間に合わず、予約内容の確認にお時間がかかる場合がございますので予めご了承ください。',
      gift_facilities:
        '宿泊同行者がベネフィット・ステーション会員様の場合は、申込者・同行者それぞれに50ベネポをプレゼントいたします  ※テキストテキスト・・・ ※テキストテキスト・・・・ ※テキストテキスト・・・・',
      hasCoupon: 1,
      useBenepoPoint: false,
      hasInfoDetail: false,
      error_message_note: '',
      totalFee: 0,
      dataRoom: {
        stayDays: [],
        member: {
          man: 0,
          woman: 0
        },
        visitors: {
          man: 0,
          woman: 0
        },
        children: {
          childrenMember10: 0,
          childrenMember15: 0,
          childrenMember20: 0,
          childrenMember30: 0,
          childrenMember40: 0,
          childrenMember50: 0,

          childrenVisitor10: 0,
          childrenVisitor15: 0,
          childrenVisitor20: 0,
          childrenVisitor30: 0,
          childrenVisitor40: 0,
          childrenVisitor50: 0
        },
        adultCount: 0,
        childrenCount: 0,
        roomAmount: 0
      },
      stayRoomDetails: [],
      tempStayRoomDetails: [],
      showRelationship: false,
      totalAdultCntMember: null,
      error_message_age_relationship: '',
      error_message_sei_relationship: '',
      error_message_mei_relationship: '',
      showRelationName: false,
      isReRenderListRoom: false,
      useCoupon: false,
      roomBasicInfoNote: '',
      noteMatters: [],
      profileInfo: null,
      isFullInfoProfile: false,
      maxStayCapacity: 19,
      minStayCapacity: 1,
      roomErrors: [],
      bothRoomError: [],
      isValidateNative: false,
      stayDateRoom: {
        date: moment(),
        stayNight: 1,
        stayRoom: 1
      },
      stayNightOptions: [],
      roomOptions: [],
      styleButton: 'disabled-btn',
      errorMessageHour: null,
      statusErrorHour: true,
      statusErrorValidateMinAdult: 0,
      adultPublicSubsidy: 0,
      childPublicSubsidy: 0,
      checkAccommondationWithSubsidy: true,
      arrInputPriceErrorMsg: [],
      checkValidateMemberErrorMsg: false,
      arrCheckPriceLessThanOne: [],
      departureTime: null,
      errMsgDeparuteTime: [],
      showErrMsgDeparuteTime: false,
      arrCheckAmountPeopleInputErrMsg: [],
      errorMsgSelectDeparuteTime: null,
      hasNext: false,
      errMsgStayDateRoom: null,
      isAcceptRequire: false,
      memberAdults: 0,
      visitorAdults: 0,
      memberChldDetails: 0,
      visitorChldDetails: 0,
      menuRcSttDt: null,
      menuRcEndDt: null,
    }
  },

  created() {
    console.log('created 02_001_NEW')
    this.dump(this.stayDateRoom)
    for (let i = 1; i <= 6; i++) {
      const data = {
        value: i,
        text: i
      }
      this.stayNightOptions.push(data)
    }
    for (let i = 1; i <= 9; i++) {
      const data = {
        value: i,
        text: i
      }
      this.roomOptions.push(data)
    }
    this.getPlanBasicInfo()
    this.fetchSubsidySettingBasicList()
    this.tempStayRoomDetails = {}
  },

  mounted() {
    let orderData = _.get(this.$store.state, 'order.menuBasicInfo.menuNo', null)
    if (orderData === null) {
      this.$router.push("/interrupt")
      return
    }

    this.dev('mounted 02_001_NEW')
    // console.log('bs-app-02-001', _.get(this.$store.getters, 'bs_app.public_stay', null))
    // const orderPublicStay = this.$store.getters['order/get'].orderPublicStay
    const orderPublicStay = _.cloneDeep(_.get(this.$store.getters, 'bs_app.public_stay', null))
    const selectedRadio = _.get(this.$store.getters, 'bs_app.selected_web_radio', null)
    if (selectedRadio) {
      this.fromWebRadio = selectedRadio
      if (+selectedRadio === 1) {
        this.departureTime = null
      }
    }


    // 初期表示処理
    // orderPublicStay　存在チェック
    // TRUE：ブラウザバックなどで存在する場合。値取得してなければNULLセット
    if (orderPublicStay) {
      this.stayRoomDetails = _.get(orderPublicStay, 'peopleRoom', null)
      this.checkboxMobile = _.get(orderPublicStay, 'checkboxMobile', null)
      this.adultPublicSubsidy = _.get(orderPublicStay, 'adultPublicSubsidy', 0)
      this.childPublicSubsidy = _.get(orderPublicStay, 'childPublicSubsidy', 0)
      if (+selectedRadio === 2) {
        this.departureTime = _.get(orderPublicStay, 'departureTime', null)
      }
      this.stayDateRoom = _.get(orderPublicStay, 'stayDateRoom', null)
    } 
    // else {
    this.onAddStayNightAndRoom()
    this.customerPlan = this.customerPlanState
    this.getProfileInfo()
    this.checkConditionHour()
    const dataItemOrder = this.$store.getters['order/get'].dataItemPublicStay
    const menuNo = _.get(dataItemOrder, 'menu_id', '')
    this.$repositories('order')
      .getOrderPulbicStayParam(menuNo)
      .then(
        (response) => {
          if (response) {
            console.log('response: ', response)
            this.stayParam = response
            this.adultPublicSubsidy = _.get(response, 'pblcBenefitsInfo.adultPublicSubsidy', 0)
            this.childPublicSubsidy = _.get(response, 'pblcBenefitsInfo.childPublicSubsidy', 0)
            this.menuRcSttDt = _.get(response, 'menuBasicInfo.menuRcSttDt', null)
            this.menuRcEndDt = _.get(response, 'menuBasicInfo.menuRcEndDt', null)
            // CRM独自対応
            // this.$dataLayer.overwrite({
            //   event: process.env.VUE_APP_GTM_EVENT_ORDER_COMPLETE,
            //   menuNo: response.menuBasicInfo?.menuNo,
            //   menuName: response.menuBasicInfo?.menuNm,
            //   catLrgClass: response.menuBasicInfo?.categoryInfomation?.catLrgClassCd,
            //   catMidClass: response.menuBasicInfo?.categoryInfomation?.catMidClassCd,
            //   catSmlClass: response.menuBasicInfo?.categoryInfomation?.catSmlClassCd,
            //   menuImageUrl: response.menuBasicInfo?.menuImages[0]?.imageUrl
            // })
          }
        },
        (error) => {
          this.$toasted.error(error?.message)
        }
      )
    // }
    console.log('this.stayRoomDetails ', this.stayRoomDetails)
  },

  computed: {
    baseOnPrice() {
      return this.$store.getters.baseOnPrice
    },

    customerPlanState() {
      return cloneDeep(_.get(this.$store.getters.customerPlan))
    },

    calculateTotalAmount() {
      let amount = 0
      if (this.stayRoomDetails && Array.isArray(this.stayRoomDetails)) {
        this.stayRoomDetails.forEach((el) => {
          amount += el.roomAmount ? el.roomAmount : 0
        })
      }
      return amount
    },

    countAdultPeople() {
      let count = 0
      if (this.stayRoomDetails && Array.isArray(this.stayRoomDetails)) {
        this.stayRoomDetails.forEach((el) => {
          const members =
            (el.member && el.member.man ? +el.member.man : 0) +
            (el.member && el.member.woman ? +el.member.woman : 0)
          const visitors =
            (el.visitors && el.visitors.man ? +el.visitors.man : 0) +
            (el.visitors && el.visitors.woman ? +el.visitors.woman : 0)
          count += members + visitors
        })
      }
      return count
    },

    totalChildren() {
      return Array.isArray(this.stayRoomDetails)
        ? this.stayRoomDetails
          .map((item) => item.childrenCount)
          .reduce((a, b) => a + b, 0)
        : 0
    },

    inputFormDataWatch() {
      let result = ''
      for (const key in this.inputFormData) {
        if (!key.includes('error')) result += this.inputFormData[key]
      }
      return result
    },
  },

  watch: {
    // stayDateRoom() {
    //   this.checkConditionHour()
    // },
    countAdultPeople() {
      this.validateRoom()
    },

    stayRoomDetails: {
      deep: true,
      handler() {
        this.statusErrorValidateMinAdult += 1
      }
    },

    checkboxMobile() {
      if(this.checkboxMobile) {
        this.styleButton = 'btn-grey'
      }else{
        this.styleButton = 'disabled-btn'
      }
    },

    totalChildren() {
      this.validateRoom()
    },

    inputFormDataWatch() {
      if (!this.isValidateNative) return
      this.validateRepresentativePeople()
    }
  },

  methods: {
    dev(msg){
      // alert(msg)
      // console.log(msg)
    },
    dump(...args){
      console.log(...args)
    },
    getNestedValue(obj, path, defaultValue) {
      return get(obj, path, defaultValue);
    },
    confirmRoomPeople() {
      // UIで設定された情報をもとに
      this.caculateAccommodationAmount(this.stayRoomDetails)
      if (!this.validateRoom()) {
        this.dev('validateRoom false')
        this.scrollToError()
        return
      }
      // クーポン情報をcustomerPlanに設定(PeopleRelationship設定用)
      if (!this.setCustomerPlanStoreDataForApllyCoupon()) return;
      // コンポーネント表示→内部でStore参照
      this.isReRenderListRoom = true
      setTimeout(() => {
        this.isReRenderListRoom = false
      }, 500)
      // ----------------------------------------
      // 承認用コンポーネントで必要なデータを設定
      // 編集用データとして設定（承認用コンポーネントに引き渡し）
      // ----------------------------------------
      const publicstay = this.buildPublicStayInfo()
      this.dump('人数確定時 publicstay', publicstay)
      this.tempStayRoomDetails = generateRoomDetailsForApplyCoupon(publicstay);
      // 表示
      this.showRelationship = true
    },
    changeConfirmRequire(val) {
      this.isAcceptRequire = val
    },
    onChangeCheckinTm() {
      this.checkConditionHour()
      this.validateDepartureTime(this.departureTime)
    },

    onChangeWeb($event) {
      this.checkConditionHour()
      this.validateDepartureTime(this.departureTime)
      this.fromWebRadio = +($event.target.value)
      if (+this.fromWebRadio === 1) {
        this.departureTime = null
      }
    },

    onChangeDeparture() {
      this.validateDepartureTime(this.departureTime)
    },

    caculateAccommodationAmount(peopleRoom) {
      this.arrInputPriceErrorMsg = []
      this.arrCheckPriceLessThanOne = []
      this.arrCheckAmountPeopleInputErrMsg = []
      // this.adultPublicSubsidy = 2500
      // this.childPublicSubsidy = 500
      if (peopleRoom) {
        let validateMember = false
        peopleRoom.forEach((el, index) => {
          const member = _.get(el, 'member.man', 0)
          const child = _.get(el, 'children.childrenMember10', 0)
          const child2 = _.get(el, 'children.childrenMember15', 0)
          const vist = _.get(el, 'visitors.man', 0)
          const vistChild = _.get(el, 'children.childrenVisitor10', 0)

          const memberPrice = _.get(el, 'member.manPrice', 0)
          const childMemberPrice = _.get(el, 'children.childrenMember10Price', 0)
          const child2Price = _.get(el, 'children.childrenMember15Price', 0)
          const vistPrice = _.get(el, 'visitors.visitorManPrice', 0)
          const vistChildPrice = _.get(el, 'children.childrenVisitor10Price', 0)
          if (member > 0 && memberPrice < this.adultPublicSubsidy) {
            this.arrInputPriceErrorMsg.push(
              {
                rooms: index + 1,
                option: '大人',
                price: memberPrice
              }
            )
          }
          if (child > 0 && childMemberPrice < this.childPublicSubsidy) {
            this.arrInputPriceErrorMsg.push(
              {
                rooms: index + 1,
                option: '小学生',
                price: childMemberPrice
              }
            )
          }
          // 会員とビジターの入力チェック
          // #64591 ビジター（有料の小学生）が人数にカウントされていないためvistChildを追加
          const conditionValidateMember = ((+member === 1 && ((+vist + vistChild + +child) > 0)) || +member > 1)
          if (!conditionValidateMember) {
            validateMember = true
          }
          if (+member > 0 && +memberPrice <= 0) {
            this.arrCheckPriceLessThanOne.push(
              { rooms: index + 1, label: '会員大人'}
            )
          }
          if (+child > 0 && +childMemberPrice <= 0) {
            this.arrCheckPriceLessThanOne.push(
              { rooms: index + 1, label: '会員有料の小学生'}
            )
          }
          if (+child2 > 0 && +child2Price <= 0) {
            this.arrCheckPriceLessThanOne.push(
              { rooms: index + 1, label: '会員有料の幼児'}
            )
          }
          if (+vist > 0 && +vistPrice <= 0) {
            this.arrCheckPriceLessThanOne.push(
              { rooms: index + 1, label: 'ビジター大人'}
            )
          }
          if (+vistChild > 0 && +vistChildPrice <= 0) {
            this.arrCheckPriceLessThanOne.push(
              { rooms: index + 1, label: 'ビジター有料の小学生'}
            )
          }

          if (+member <= 0 && +memberPrice > 0) {
            this.arrCheckAmountPeopleInputErrMsg.push(
              { rooms: index + 1, label: '会員大人'}
            )
          }
          if (+child <= 0 && +childMemberPrice > 0) {
            this.arrCheckAmountPeopleInputErrMsg.push(
              { rooms: index + 1, label: '会員有料の小学生'}
            )
          }
          if (+child2 <= 0 && +child2Price > 0) {
            this.arrCheckAmountPeopleInputErrMsg.push(
              { rooms: index + 1, label: '会員有料の幼児'}
            )
          }
          if (+vist <= 0 && +vistPrice > 0) {
            this.arrCheckAmountPeopleInputErrMsg.push(
              { rooms: index + 1, label: 'ビジター大人'}
            )
          }
          if (+vistChild <= 0 && +vistChildPrice > 0) {
            this.arrCheckAmountPeopleInputErrMsg.push(
              { rooms: index + 1, label: 'ビジター有料の小学生'}
            )
          }
        })
        this.checkValidateMemberErrorMsg = validateMember
      }
    },

    checkConditionHour() {
      this.errorMessageHour = null
      this.statusErrorHour = true
      const checkInDay = this.stayDateRoom.date
      const day = moment(new Date())
      console.log('>>>> 0', moment(checkInDay).isSame(day, 'day'))
      if(moment(checkInDay).isSame(day, 'day')) {
        const hour = day.get('hour')
        if (+hour >= 18) {
          this.statusErrorHour = false
          this.errorMessageHour = '宿泊日の18時以降は申込できません。'
        }
      }
    },

    getProfileInfo() {
      this.$store.dispatch(GET_PROFILE).then((data) => {
        this.profileInfo = data
        const postalCode = _.get(data, 'addresses[0].postalCode', null)
        const address1 = _.get(data, 'addresses[0].address1', null)
        const address2 = _.get(data, 'addresses[0].address2', null)
        const email = _.get(data, 'email', null)
        const tel = _.get(data, 'tel', null)
        if (postalCode && address1 && address2 && email && tel) {
          this.isFullInfoProfile = true
        } else {
          this.isFullInfoProfile = false
        }
      })
    },

    onChangeFamilyNameKana(e) {
      const input = e.target.value
      this.inputFormData.familyNameKana = this.onReplaceKanaRomaji(input)
    },

    onChangeFirstNameKana(e) {
      const input = e.target.value
      this.inputFormData.firstNameKana = this.onReplaceKanaRomaji(input)
    },

    onChangeFamilyName(e) {
      const input = e.target.value
      this.inputFormData.familyName = this.onReplaceKanjiRomaji(input)
    },

    onChangeFirstName(e) {
      const input = e.target.value
      this.inputFormData.firstName = this.onReplaceKanjiRomaji(input)
    },

    getPlanBasicInfo() {
      const menuBasicInfo = this.$store.state.order.menuBasicInfo
      this.dataItemOrder = {
        type: 'type-small',
        menu_id: get(menuBasicInfo, 'menuNo', ''),
        label: get(menuBasicInfo, 'categoryInfomation', {}),
        baseImg: get(menuBasicInfo, 'menuImages[0].imageUrl', ''),
        title1: get(menuBasicInfo, 'menuNm', '')
      }
    },

    async fetchSubsidySettingBasicList() {
      const subsidyList = this.$store.getters['order/get'].subsidyAvailables
      let subsidySettingBasicList = null
      this.dump('param subusidyList', subsidyList)
      if (subsidyList && subsidyList.length > 0) {
        this.dev('fetchSubsidySettingBasicList')
        subsidySettingBasicList = await this.$repositories('coupon')
          .getSubsidySettingBasicList({
            filterBy: 'subsidy_id',
            filterOp: 'in',
            filterValue: subsidyList.map(s => s.availableData.subsidyId).join('|'),
          })
          .catch((error) => {
            return error
          })
        this.dump('subsidySettingBasicList', subsidySettingBasicList)
      }
      // 01:企業負担（預り金精算） 02:企業負担（実費請求） 05:その他
      if (subsidySettingBasicList.setting != null && subsidySettingBasicList.setting.some(s => ["01", "02", "05"].includes(s.payOffForm))) {
        this.dump('checkAccommondationWithSubsidy true')
        this.showRelationName = true
      }
      else {
        this.dump('checkAccommondationWithSubsidy false')
        this.showRelationName = false
      }
    },
    onBlur() {
      const age = get(this.inputFormData, 'age', '')
      if (age < 1) {
        this.inputFormData.age = null
      } else if (age[0] === '0' || age[0] === '０') {
        this.inputFormData.age = age[1]
      }
    },

    validateRepresentativePeople() {
      let pass = true
      const isFormatKana =
        this.validateTextKana(this.inputFormData.familyNameKana) &&
        this.validateTextKana(this.inputFormData.firstNameKana)
      const isFormatKanji =
        this.validateTextKanji(this.inputFormData.familyName) &&
        this.validateTextKanji(this.inputFormData.firstName)
      if (this.valueCheckbox1) {
        const kanaLength =
          get(this.inputFormData, 'familyNameKana.length') +
          get(this.inputFormData, 'firstNameKana.length')
        if (kanaLength) {
          this.inputFormData.familyNameKana = this.inputFormData.familyNameKana.trim()
          this.inputFormData.firstNameKana = this.inputFormData.firstNameKana.trim()
        }
        if (!this.inputFormData.familyNameKana || !this.inputFormData.firstNameKana) {
          this.inputFormData.error_message_name_kana = MESSAGE_ERROR.FORM_FAMILY_NAME_KANA
          this.errors.push({
            name: 'firstNameKanaError',
            message: this.inputFormData.error_message_name_kana
          })
          pass = false
        } else if (!isFormatKana) {
          this.inputFormData.error_message_name_kana = MESSAGE_ERROR.FORMAT_ERROR
          this.errors.push({
            name: 'firstNameKanaError',
            message: this.inputFormData.error_message_name_kana
          })
          pass = false
        } else {
          this.inputFormData.error_message_name_kana = ''
        }
        const kanjiLength =
          get(this.inputFormData, 'familyName.length') +
          get(this.inputFormData, 'firstName.length')
        if (kanjiLength) {
          this.inputFormData.familyName = this.inputFormData.familyName.trim()
          this.inputFormData.firstName = this.inputFormData.firstName.trim()
        }
        if (!this.inputFormData.familyName || !this.inputFormData.firstName) {
          this.inputFormData.error_message_name = MESSAGE_ERROR.FORM_FAMILY_NAME_KANJI
          this.errors.push({
            name: 'firstNameError',
            message: this.inputFormData.error_message_name
          })
          pass = false
        } else if (!isFormatKanji) {
          this.inputFormData.error_message_name = MESSAGE_ERROR.FORMAT_ERROR
          this.errors.push({
            name: 'firstNameError',
            message: this.inputFormData.error_message_name
          })
          pass = false
        } else {
          this.inputFormData.familyName = this.inputFormData.familyName.trim()
          this.inputFormData.firstName = this.inputFormData.firstName.trim()
          this.inputFormData.error_message_name = ''
        }
        if (this.inputFormData.familyRelationship === '選択してください') {
          this.inputFormData.error_message_rela = MESSAGE_ERROR.FORM_FAMILY_COMMON
          this.errors.push({
            name: 'familyRelationshipError',
            message: this.inputFormData.error_message_rela
          })
          pass = false
        } else {
          this.inputFormData.error_message_rela = ''
        }
        if (this.inputFormData.isVisitor === null) {
          this.inputFormData.error_message_visitor = MESSAGE_ERROR.FORM_FAMILY_VISITOR
          this.errors.push({
            name: 'isVisitorError',
            message: this.inputFormData.error_message_visitor
          })
          pass = false
        } else {
          this.inputFormData.error_message_visitor = ''
        }
        if (this.inputFormData.gender === null) {
          this.inputFormData.error_message_gender = MESSAGE_ERROR.FORM_FAMILY_GENDER
          this.errors.push({
            name: 'genderError',
            message: this.inputFormData.error_message_gender
          })
          pass = false
        } else {
          this.inputFormData.error_message_gender = ''
        }
        if (this.inputFormData.age && this.inputFormData.age > 1) {
          this.inputFormData.error_message_age = ''
        } else {
          this.inputFormData.error_message_age = MESSAGE_ERROR.FORM_FAMILY_AGE
          this.errors.push({
            name: 'ageError',
            message: this.inputFormData.error_message_age
          })
          pass = false
        }
      }
      return pass
    },

    validateStayDateRoom() {
      let pass = true

      const date = this.stayDateRoom.date
      const stayNight = this.stayDateRoom.stayNight

      // 全宿泊日が有効な日付かチェックする
      for(let night = 1; night <= stayNight; night++) {
        // 1泊目はdateそのまま 2泊目以降は日数加算しチェック
        if (this.checkDisabledDate(moment(date).add(night-1, 'days'))) {
          this.errMsgStayDateRoom = '指定された日付では利用できません。'
          this.errors.push({
            name: 'stay-date-room',
          })
          pass = false
        }
      }

      return pass
    },

    validateRoom() {

      this.memberAdults = 0;
      this.visitorAdults = 0;
      this.memberChldDetails = {
        childrenMember10: 0,
        childrenMember15: 0,
        childrenMember20: 0,
        childrenMember30: 0, 
        childrenMember40: 0, 
        childrenMember50: 0, 
      };
      this.visitorChldDetails = {
        childrenVisitor10: 0,
        childrenVisitor15: 0,
        childrenVisitor20: 0,
        childrenVisitor30: 0, 
        childrenVisitor40: 0, 
        childrenVisitor50: 0,
      };
      
      let memberPeopleCnt = 0
      let allPeopleCnt = 0
      let hasInsufficientRoomMembers = false

      let pass = true
      const roomErrors = []
      this.roomErrors = []
      
      this.dev('validateRoom 1')
      this.stayRoomDetails.forEach((room, index) => {
        this.dump('room ', room)
        const itemMemberAdults =
          ~~get(room, 'member.man', 0) + ~~get(room, 'member.woman', 0)

        const itemVisitorAdults =
          ~~get(room, 'visitors.man', 0) + ~~get(room, 'visitors.woman', 0)
        const member10 = _.get(room, 'children.childrenMember10', 0)
        const vistChild10 = _.get(room, 'children.childrenVisitor10', 0)
        this.dev('validateRoom 2')
        const itemChildrenMember =
          room.children.childrenMember10 +
          room.children.childrenMember15 +
          room.children.childrenMember20 +
          room.children.childrenMember30 +
          room.children.childrenMember40 +
          room.children.childrenMember50

        const itemChildrenVisitor =
          room.children.childrenVisitor10 +
          room.children.childrenVisitor15 +
          room.children.childrenVisitor20 +
          room.children.childrenVisitor30 +
          room.children.childrenVisitor40 +
          room.children.childrenVisitor50

        const itemAllPeopleCnt =
          itemMemberAdults + itemChildrenMember + itemVisitorAdults + itemChildrenVisitor

        memberPeopleCnt += itemMemberAdults + itemChildrenMember
        allPeopleCnt += itemAllPeopleCnt

        const eachRoomErrors = []
        
        // 大人会員1名 + その他(大人ビジター + 小学生の会員・ビジター)1名以上 or 大人会員2名
        const conditionValidateMember = ((+itemMemberAdults === 1 && ((+itemVisitorAdults + member10 + +vistChild10) > 0)) || +itemMemberAdults > 1)

        if (!conditionValidateMember) {
          hasInsufficientRoomMembers = true
        }

        // số người không đạt tối thiểu
        if (!itemAllPeopleCnt) {
          pass = false
          eachRoomErrors.push(`${index + 1} 部屋目にはあと1名以上の設定が必要です`)
        }

        this.dev('validateRoom 3')
        if (pass) {
          // 補助金ダイアログで利用するデータ構造の作成
          this.memberAdults += itemMemberAdults;
          this.visitorAdults += itemVisitorAdults;
          this.memberChldDetails.childrenMember10 += ~~get(room, 'children.childrenMember10', 0);
          this.memberChldDetails.childrenMember15 += ~~get(room, 'children.childrenMember15', 0);
          this.memberChldDetails.childrenMember20 += ~~get(room, 'children.childrenMember20', 0);
          this.memberChldDetails.childrenMember30 += ~~get(room, 'children.childrenMember30', 0);
          this.memberChldDetails.childrenMember40 += ~~get(room, 'children.childrenMember40', 0);
          this.memberChldDetails.childrenMember50 += ~~get(room, 'children.childrenMember50', 0);
          this.visitorChldDetails.childrenVisitor10 += ~~get(room, 'children.childrenVisitor10', 0);
          this.visitorChldDetails.childrenVisitor15 += ~~get(room, 'children.childrenVisitor15', 0);
          this.visitorChldDetails.childrenVisitor20 += ~~get(room, 'children.childrenVisitor20', 0);
          this.visitorChldDetails.childrenVisitor30 += ~~get(room, 'children.childrenVisitor30', 0);
          this.visitorChldDetails.childrenVisitor40 += ~~get(room, 'children.childrenVisitor40', 0);
          this.visitorChldDetails.childrenVisitor50 += ~~get(room, 'children.childrenVisitor50', 0);
        }
        roomErrors.push(eachRoomErrors)
      })
      this.roomErrors = roomErrors
      this.dev('validateRoom 4')
      // Số người khác room
      const bothRoomError = []
      if (allPeopleCnt > 19) {
        bothRoomError.push('1度の申込で予約可能な最大人数は19名となります。')
      }

      if (hasInsufficientRoomMembers) {
        bothRoomError.push('1部屋につき最低2名以上、うち会員大人を1名以上入力が必要です。')
      }

      this.dev('validateRoom 5')
      this.bothRoomError = bothRoomError
      if (bothRoomError.length) {
        pass = false
      }
      this.dev('validateRoom 6')

      return pass
    },

    checkValidate() {
      let hasError = false

      // validate form representative people
      if (!this.validateRepresentativePeople()) {
        hasError = true
      }

      // validate stay date room
      if (!this.validateStayDateRoom()) {
        hasError = true
      }

      // validate room
      if (!this.validateRoom()) {
        hasError = true
      }

      // if (!this.validateQuestionList()) {
      //   hasError = true
      // }

      if (!this.validateDepartureTime(this.departureTime)) {
        hasError = true
      }

      // if(!this.checkTimeCheckIn()) {
      //   hasError = true
      // }

      if (!this.validateRelationshipMsg()) {
        hasError = true
      }
      return hasError
    },


    validateDepartureTime(departureTime) {
      const currentTime = moment()
      this.errMsgDeparuteTime = []
      let valid = true
      if (departureTime) {

        const dateDiff = departureTime.diff(currentTime, 'day') + 1
        console.log('DIFF ', dateDiff)
        if (+dateDiff <= 4) {
          valid = false
          this.errMsgDeparuteTime.push('指定された日付にて利用いただけません。ご自宅出発日は郵送の場合は出発日の5日以降となります。但し、WEB印刷できる環境がある場合は本日でも利用できます。')
        }

        console.log('departureTime ', moment(departureTime).format('DD/MM/YYYY'))
        console.log('this.stayDateRoom.date ', moment(this.stayDateRoom.date).format('DD/MM/YYYY'))

        console.log('>>>>> ', moment(departureTime).isAfter(this.stayDateRoom.date, 'day'))
        // NGAY CHECK IN PHAI CUNG HOAC SAU NGAY KHOI HANH
        if (moment(departureTime).isAfter(this.stayDateRoom.date, 'day')) {
          valid = false
          this.errMsgDeparuteTime.push('ご自宅出発日は宿泊開始日よりも後の日付を選択できません。')
        }
      } else if (+this.fromWebRadio === 2) {
        valid = false
        this.errMsgDeparuteTime.push('ご自宅出発日を選択してください')
      }
      console.log(this.errMsgDeparuteTime)
      return valid
    },

    scrollToError() {
      this.dev('scrollToError')
      if (this.errors && this.errors.length > 0) {
        this.dump('this.errors', this.errors)
        const firstField = this.errors.map((e) => e.name)[0]
        if (firstField === 'questionListError') {
          this.$smoothScroll({
            scrollTo: this.$refs[`${firstField}`],
            offset: 0
          })
          return
        }
        this.$smoothScroll({
          scrollTo: this.$refs[`${firstField}`],
          offset: -400
        })
      }
      this.errors = []
    },
    
    isConfirmScreenToTransitionable() {
      return (this.isFullInfoProfile
        && this.arrInputPriceErrorMsg.length <= 0
        && !this.errorMessageHour
        && this.arrCheckPriceLessThanOne <= 0
        && this.arrCheckAmountPeopleInputErrMsg <= 0
        && !this.checkValidateMemberErrorMsg);
    },

    isAaddressScreenToTransitionable() {
      return (!this.checkValidateMemberErrorMsg  // caculateAccommodationAmount会員数チェック
        && this.arrInputPriceErrorMsg <= 0 // メニューの補助金額限度チェック
        && !this.errorMessageHour
        && this.arrCheckPriceLessThanOne <= 0
        && this.arrCheckAmountPeopleInputErrMsg <= 0);
    },

    // -----------------------------------------------------
    // ApplyCoupon、PeopleRelationShip用データcustomerPlan生成実装群 ここから
    // ----------------------------------------
    // 補助金ダイアログを利用するために、
    // 補助金ダイアログが利用しているstoreの値を設定する
    // この前工程のメニュー詳細画面（PublicStayMenuDetail\MenuDetails\index.vue）では、
    // メニュー系の基本情報を設定しているが、（setPlanDetailStoreDataForApllyCoupon）
    // ここでは、プラン系(customer)の設定情報を設定する
    // 設定する情報の源泉は、store(bs_app/public_stay（画面設定情報）)であるため、
    // この情報から計算して設定する
    // 利用していないcustomerPlanの各種属性は未設定とする
    // ※ 一部、subsidyListはこの画面で利用する、PeopleRelationShip.vueで利用するため、
    // order/subsidyAvailablesから取得して設定している。
    // -----------------------------------------------------
    setCustomerPlanStoreDataForApllyCoupon() {
      // RelationShipで参照している、補助金データ
      const subsidyList = this.$store.getters['order/get'].subsidyAvailables

      if (!subsidyList.length || !this.checkLimApplicableDateFrom(subsidyList)) {
        this.$toasted.error('利用可能な補助金がないため利用できません');
        return false;
      }

      // 下記データ源泉はvalidateRoomで格納
      const data = {
        stayDays: this.stayDateRoom.date,
        stayNights: this.stayDateRoom.stayNight,
        memberAdults: this.memberAdults,
        visitorAdults: this.visitorAdults,
        memberChldDetails: this.memberChldDetails,
        visitorChldDetails: this.visitorChldDetails,
        vacancyCalendar: this.vacancyCalendar,
        subsidyList: subsidyList,
      }
      this.$store.dispatch(SAVE_CUSTOMER_PLAN, data).then(() => {
        this.dump('save customer plan OK')
      })
      return true;
    },
    // -----------------------------------------------------
    // ApplyCoupon用データcustomerPlan生成実装群 ここまで
    // ----------------------------------------

    checkLimApplicableDateFrom(subsidyList) {
      let isAvailable = false;
      const stayDay = moment(this.stayDateRoom.date);
      const stayNight = this.stayDateRoom.stayNight;
      if (subsidyList) {
        const priceList = [];
        subsidyList.forEach(row => {
          const data = row?.availableData?.priceList;
          if (data) data.forEach(row => priceList.push(row));
        });
        const checkAvailable = (date) => {
          for(let i = 0; i < priceList.length; i++) {
            if(
              moment(priceList[i].limApplicableDateFrom).isSameOrBefore(date, 'day') &&
              moment(priceList[i].limApplicableDateTo).isSameOrAfter(date, 'day')
            ) {
              return true;
            }
          }
          return false;
        };
        const check = [];
        for(let i = 0; i < stayNight; i++) {
          const date = stayDay.add(i, 'd');
          check.push(checkAvailable(date));
        }
        isAvailable = check.indexOf(false) >= 0 ? false : true;
      }
      return isAvailable;
    },
    
    // ----------------------------------------
    // UIで設定された情報の構造をStoreで引き回す構造に変換する
    // ※既存実装の関数化
    // ----------------------------------------
    buildPublicStayInfo() {
      const publicStayInfo = {
        stayDateRoom: this.stayDateRoom,
        peopleRoom: this.stayRoomDetails,
        profileInfo: this.profileInfo,
        adultPublicSubsidy: this.adultPublicSubsidy,
        childPublicSubsidy: this.childPublicSubsidy,
        departureTime: moment(this.departureTime),
        stayParam: this.stayParam
      }
      return publicStayInfo
    },

    handleDataSave() {
      const data = {
        checkinTime: this.checkinTime,
        totalFee: this.calculateTotalAmount,
        totalAdultPeople: this.countAdultPeople,
        totalChildren: this.totalChildren,
        stayRoomDetails: this.stayRoomDetails,
      }
      return data
    },

    handleNext() {
      this.hasNext = true
      const data = this.handleDataSave()

      this.dev("handleNext 1")
      this.errMsgStayDateRoom = null
      if (+this.fromWebRadio === 2) {
        this.errorMessageHour = null
      } else {
        this.statusErrorHour = true
      }

      this.statusError = true
      this.arrInputPriceErrorMsg = []
      this.arrCheckPriceLessThanOne = []
      this.arrCheckAmountPeopleInputErrMsg = []
      this.caculateAccommodationAmount(this.stayRoomDetails)
      if (this.checkValidate()) {
        this.scrollToError()
        return
      }

      this.dev("handleNext 2")
      const query = this.$route.query
      const totalAdult = this.countAdultPeople
      this.$store.commit('order/setOrderPublicStay', {
        stayDateRoom: this.stayDateRoom,
        peopleRoom: this.stayRoomDetails,
        profileInfo: this.profileInfo,
        adultPublicSubsidy: this.adultPublicSubsidy,
        childPublicSubsidy: this.childPublicSubsidy,
        departureTime: moment(this.departureTime),
        stayParam: this.stayParam
      })

      this.dev("handleNext 3")
      const dataPublicStay = this.buildPublicStayInfo()
      this.dump("人数確定時、この情報セットを作成して、roomdetail情報を作成する",dataPublicStay)
      this.dev("handleNext 4")
      this.$store.dispatch(SAVE_PUBLIC_STAY, dataPublicStay).then(() => {
        this.dump('save dataPublicStay OK')
      })

      this.dev("handleNext 4-2")
      if (!this.setCustomerPlanStoreDataForApllyCoupon()) return;

      this.dev("handleNext 5")
      this.$store.dispatch(SAVE_SELECTED_WEB_RADIO, this.fromWebRadio).then(() => {
        this.dump('save this.fromWebRadio OK')
      })

      this.dev("handleNext 9")
      if (this.isAaddressScreenToTransitionable()) {
        this.dev("handleNext 10")
        if(((this.statusErrorHour && +this.fromWebRadio > 0)) && +totalAdult > 0) {
          this.$store.dispatch(SAVE_DATA_BS_APP_02_001, data).then(
            () => {
              this.$router.push({ path: 'register-address', query })
            },
            (error) => {
              this.$toasted.error(error)
            }
          )
        }
      }
      const scrollList = []

      if (scrollList.length) {
        this.$smoothScroll({
          scrollTo: this.$refs[scrollList[0]],
          offset: -200
        })
      }
    },

    handleBack() {
      this.$router.go(-1)
    },

    goto(path = null) {
      if (path) {
        if (path === '/') {
          this.$router.push({ path, query: {} })
          return
        }
        if (path === 'plan') {
          const dataItemOrder = this.$store.getters['order/get'].dataItemPublicStay
          const menuNo = _.get(dataItemOrder, 'menu_id', '')
          this.$router.push({
            path: `/public-stay/menus/${menuNo}`
          })
        }
      }
    },

    checkDisabledDate(date) {
      const now = moment(new Date())
      let selectableDate = moment(now).add(180,"days")
      if(this.menuRcEndDt != null){
        selectableDate = selectableDate.isBefore(moment(this.menuRcEndDt)) ? selectableDate : moment(this.menuRcEndDt)
      }
      return date.isBefore(now, 'date') || date.isAfter(selectableDate, 'date')
    },

    onAddStayNightAndRoom() {
      const length = this.stayRoomDetails.length
      if(this.stayRoomDetails) {
        const arrErrMsg = []
        const arrErrPriceMsg = []
        const arrErrPeopleMsg = []
        this.stayRoomDetails.forEach((el1, index) => {

          if (this.arrInputPriceErrorMsg.length > 0) {
            this.arrInputPriceErrorMsg.forEach(el2 => {
              if(+_.get(el2, 'rooms', '') === (index + 1)) {
                arrErrMsg.push(el2)
              }
            })
          }
          if (this.arrCheckPriceLessThanOne.length > 0) {
            this.arrCheckPriceLessThanOne.forEach(el3 => {
              if(+_.get(el3, 'rooms', '') === (index + 1)) {
                arrErrPriceMsg.push(el3)
              }
            })
          }
          if (this.arrCheckAmountPeopleInputErrMsg.length > 0) {
            this.arrCheckAmountPeopleInputErrMsg.forEach(el4 => {
              if(+_.get(el4, 'rooms', '') === (index + 1)) {
                arrErrPeopleMsg.push(el4)
              }
            })
          }
        })

        this.arrInputPriceErrorMsg = arrErrMsg
        this.arrCheckPriceLessThanOne = arrErrPriceMsg
        this.arrCheckAmountPeopleInputErrMsg = arrErrPeopleMsg
      }
      const { stayRoom } = this.stayDateRoom
      if (stayRoom < length) {
        this.stayRoomDetails.splice(stayRoom, length - stayRoom)
      } else {
        const data = cloneDeep(this.dataRoom)
        for (let i = 1; i <= stayRoom - length; i++) {
          this.stayRoomDetails.push(data)
        }
      }
    },


    // ----------------------------------------
    // クーポン承認情報関連実装ここから
    // ----------------------------------------
    getMessageErrorAge(message) {
      this.error_message_age_relationship = message
    },
    getMessageErrorSei(message) {
      this.error_message_sei_relationship = message
    },
    getMessageErrorMei(message) {
      this.error_message_mei_relationship = message
    },
    getAdultCntMember($event) {
      this.totalAdultCntMember = $event
    },
    onRelationshipChange($event) {
      if (this.showRelationship) {
        this.dump('onRelationshipChange (stayRoomDetails) after', $event)
        this.stayRoomDetails = $event
      }
    },

    validateRelationshipMsg() {
      if (!this.validateRelationship()) {
        this.errors.push({
          name: 'checkRelationshipError',
          message: '関係を確認するには、ボタン「人数確定」を押してください'
        })
        return false
      }
      return true
    },

    validateRelationship() {
     
      this.dev('validateRelationship 1')
      if (!this.showRelationship) {
        this.$toasted.error('関係を確認するには、ボタン「人数確定」を押してください')
        return false
      }
      //
      let hasInputAge = true
      let hasSelectRelationship = true
      let hasInputFirstNames = true
      let hasInputFamilyNames = true
      let hasInputNames = true
      this.dev('validateRelationship 2')
      this.stayRoomDetails.forEach((room) => {
        const memberCnt = room.member.man + room.member.woman
        this.totalAdultCntMember += memberCnt
        if (Array.isArray(room.relationships) && room.relationships.length) {
          room.relationships.forEach((item) => {
            if (item.isMember && !item.relationshipCode) {
              hasSelectRelationship = false
            }
            if ((item.age > 12 || item.age < 0 || !item.age) && item.isChildren) {
              hasInputAge = false
            }
            if (item.isChildren) {
              if (!this.validateAgeChild(item.age)) {
                hasInputAge = false
              }
            }
            if (this.showRelationName && !item.firstName) {
              hasInputFirstNames = false
            }
            if (this.showRelationName && !item.familyName) {
              hasInputFamilyNames = false
            }
          })
        } else if (this.showRelationship && !this.isRoomVisitorOnly(room)) {
          // 続柄選択を表示しているが、続柄を選択していない場合(room.relationshipsがない場合）エラー
          // ビジターのみの部屋はエラー扱いにしない
          hasSelectRelationship = false
        }
      })
      this.dev('validateRelationship 3')
      if (!hasSelectRelationship) {
        if (!(this.roomErrors[0].errors.length > 0)) {
          this.$toasted.error('人数確定ボタンを押し、続柄を設定してください。')
        }
        return false
      }
      if (!hasInputAge) {
        this.error_message_age_relationship =
          '会員子どもの年齢は12歳以下を入力してください。'
        return false
      }
      if (!hasInputFamilyNames) {
        this.error_message_sei_relationship = MESSAGE_ERROR.FORM_SEI_KANJI_KANA_ROMAJI
        this.$toasted.error('会員の姓を入力してください。')
        return false
      }
      if (!hasInputFirstNames) {
        this.error_message_mei_relationship = MESSAGE_ERROR.FORM_MEI_KANJI_KANA_ROMAJI
        this.$toasted.error('会員の名を入力してください。')
        return false
      } 
      return true
    },
    isRoomVisitorOnly(room) {
      if (room) {
        const member = room.member;
        const memberChildren = room.memberChildren;
        const visitors = room.visitors;
        const visitorChildren = room.visitorChildren;
        // メンバー会員が一人もいない
        if (member && member.man == 0 && member.woman == 0
            && memberChildren
            && memberChildren.childrenType10 == 0
            && memberChildren.childrenType15 == 0
            && memberChildren.childrenType20 == 0
            && memberChildren.childrenType30 == 0
            && memberChildren.childrenType40 == 0
            && memberChildren.childrenType50 == 0
        ) {
          // ビジター会員が一人以上いる
          if (visitors && (visitors.man > 0 || visitors.woman > 0)
              || (visitorChildren
                && (visitorChildren.childrenType10 > 0
                || visitorChildren.childrenType15 > 0
                || visitorChildren.childrenType20 > 0
                || visitorChildren.childrenType30 > 0
                || visitorChildren.childrenType40 > 0
                || visitorChildren.childrenType50 > 0)
              )
          ) {
            return true;
          }
        }
      }
      return false;
    },
    // ----------------------------------------
    // クーポン承認情報関連実装ここまで
    // ----------------------------------------

    trimSpace() {
      this.inputFormData.familyName = this.inputFormData && this.inputFormData.familyName ? this.inputFormData.familyName.trim() : ''
      this.inputFormData.firstName = this.inputFormData && this.inputFormData.firstName ? this.inputFormData.firstName.trim() : ''
      this.inputFormData.familyNameKana = this.inputFormData && this.inputFormData.familyNameKana ? this.inputFormData.familyNameKana.trim() : ''
      this.inputFormData.firstNameKana = this.inputFormData  && this.inputFormData.firstNameKana ? this.inputFormData.firstNameKana.trim() : ''
    }
  }
}
</script>

<style lang="scss" scoped>
@import 'styles';
</style>
